import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { setWallCloseStateWrap } from '../../../../../../action';
import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, jTrimModel, wainscotTrimModel } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../CustomMaterial';

const TrimModel = () => {
    const dispatch = useDispatch();
    const wallCloseStateWrap = useSelector(state => state.reducer.wallCloseStateWrap)

    const [frontWallCloseSize, setFrontWallCloseSize] = useState(0);
    const [backWallCloseSize, setBackWallCloseSize] = useState(0);
    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);
    const [sideWallLeftPorchSize, setSideWallLeftPorchSize] = useState(0);
    const [sideWallRightPorchSize, setSideWallRightPorchSize] = useState(0);

    const wallThickness = 0.005;

    const sideJTrimState = params.p_j_t && params.p_b_c_b_l !== "Open" && params.p_b_c_b_l !== "Close";
    const frontJTrimState = params.p_j_t_end && params.p_b_c_b_l_f !== "Open" && params.p_b_c_b_l_f !== "Close" && params.p_b_c_b_l_f !== "Half Dutch End" && params.p_b_c_b_l_f !== "Half End";
    const backtJTrimState = params.p_j_t_end && params.p_b_c_b_l_b !== "Open" && params.p_b_c_b_l_b !== "Close" && params.p_b_c_b_l_b !== "Half Dutch End" && params.p_b_c_b_l_b !== "Half End";
    const offsetHeight = (params.p_r_s === 1) ? 0.04 : 0;
    
    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation === "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption === "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture === "none" || params.wainscotTexture === "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);
    
    const frontWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l_f === "Open" || params.p_b_c_b_l_f === "Gable" || params.add_left_front_lean_porch || params.p_b_c_b_l === 'Close')) {
            model.moveTo(-(params.lean_p_d / 2 ), params.lean_p_h + offsetHeight);
            model.lineTo(-(params.lean_p_d / 2 ), frontWallCloseSize);
            model.lineTo(-(params.lean_p_d / 2 + 0.235), frontWallCloseSize);
            model.lineTo(-(params.lean_p_d / 2 + 0.235), params.lean_p_h + offsetHeight);
            model.closePath();
        } else if (params.add_left_front_lean_porch && (frontWallCloseSize < sideWallCloseSize)) {
            model.moveTo(-(params.lean_p_d / 2 ), sideWallCloseSize);
            model.lineTo(-(params.lean_p_d / 2 ), frontWallCloseSize);
            model.lineTo(-(params.lean_p_d / 2 + 0.235), frontWallCloseSize);
            model.lineTo(-(params.lean_p_d / 2 + 0.235), sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [frontWallCloseSize, sideWallCloseSize, params.p_b_c_b_l_f, params.add_left_front_lean_porch, params.lean_p_h, params.lean_p_d, offsetHeight, params.p_b_c_b_l])

    const leftLeanFrontTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(wallCloseStateWrap.LLFrontWallCloseState !== undefined){
            if((params.p_f_w === 'Open' || params.p_f_w === 'Gable') && params.p_l_w === 'Open' && params.p_b_c_b_l_f !== 'Open' && !params.add_front_lean && (params.lean_p_d === params.p_d || (params.lean_p_d !== params.p_d && Number(params.leantoAlignmentLeft) === 2))){
                model.moveTo(-(params.p_d / 2 + 0.26), wallCloseStateWrap.LLFrontWallCloseState);
                model.lineTo(-(params.p_d / 2 + 0.26), params.p_h) 
                model.lineTo(-(params.p_d / 2 + 0.03), params.p_h)
                model.lineTo(-(params.p_d / 2 + 0.03), wallCloseStateWrap.LLFrontWallCloseState);
                model.closePath();
            }
        }

        return model;
    
    }, [params.p_f_w,params.p_h, params.p_d, wallCloseStateWrap.LLFrontWallCloseState, params.p_l_w, params.p_b_c_b_l_f, params.add_front_lean, params.lean_p_d, params.leantoAlignmentLeft])

    const leftLeanBackTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(wallCloseStateWrap.LLBackWallCloseState !== undefined){
            if((params.p_b_w === 'Open' || params.p_b_w === 'Gable') && params.p_l_w === 'Open' && params.p_b_c_b_l_b !== 'Open' && !params.add_back_lean && (params.lean_p_d === params.p_d || (params.lean_p_d !== params.p_d && Number(params.leantoAlignmentLeft) === 3))){
                model.moveTo(params.p_d / 2 + 0.03, wallCloseStateWrap.LLBackWallCloseState);
                model.lineTo(params.p_d / 2 + 0.03, params.p_h) 
                model.lineTo(params.p_d / 2 + 0.26, params.p_h)
                model.lineTo(params.p_d / 2 + 0.26, wallCloseStateWrap.LLBackWallCloseState);
                model.closePath();
            }
        }
        return model;
    
    }, [params.p_b_w,params.p_h, params.p_d, wallCloseStateWrap.LLBackWallCloseState, params.p_l_w, params.p_b_c_b_l_b, params.add_back_lean, params.lean_p_d, params.leantoAlignmentLeft])

    const dutchDelModelFront = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        let cornerFreeSpaceW = (params.lean_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.lean_p_h - ((params.b_l_t_r_p / 12) * params.lean_p_w) :  params.lean_p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_left_lean && (params.p_b_c_b_l_f === "Half Dutch End" || params.p_b_c_b_l_f === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.lean_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_l_f === "Half Dutch End") {
                model.lineTo(-(params.lean_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.lean_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.lean_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.lean_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.lean_p_w / 2 - freeSpace), 0);
                model.lineTo((params.lean_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.lean_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.lean_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.lean_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.lean_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.lean_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.lean_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.lean_p_w / 2 - freeSpace), 0);
                model.lineTo((params.lean_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.lean_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.lean_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.lean_p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.add_left_lean, params.lean_p_w, params.lean_p_h, params.p_b_c_b_l_f])


    const dutchDelModelBack = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        let cornerFreeSpaceW = (params.lean_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.lean_p_h - ((params.b_l_t_r_p / 12) * params.lean_p_w) :  params.lean_p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_left_lean && (params.p_b_c_b_l_b === "Half Dutch End" || params.p_b_c_b_l_b === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.lean_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_l_b === "Half Dutch End") {
                model.lineTo(-(params.lean_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.lean_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.lean_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.lean_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.lean_p_w / 2 - freeSpace), 0);
                model.lineTo((params.lean_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.lean_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.lean_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.lean_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.lean_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.lean_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.lean_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.lean_p_w / 2 - freeSpace), 0);
                model.lineTo((params.lean_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.lean_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.lean_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.lean_p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.add_left_lean, params.lean_p_w, params.lean_p_h, params.p_b_c_b_l_b])

    const backWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l_b === "Open" || params.p_b_c_b_l_b === "Gable" || params.add_left_back_lean_porch || params.p_b_c_b_l === 'Close')) {
            if(params.p_b_c_b_l !== 'Close' && params.add_left_back_lean_porch){
                model.moveTo(params.lean_p_d / 2 , backWallCloseSize);
                model.lineTo(params.lean_p_d / 2 , sideWallCloseSize);
                model.lineTo(params.lean_p_d / 2 + 0.23, sideWallCloseSize);
                model.lineTo(params.lean_p_d / 2 + 0.23, backWallCloseSize);
                model.closePath();
            } else {
                model.moveTo(params.lean_p_d / 2 , backWallCloseSize);
                model.lineTo(params.lean_p_d / 2 , params.lean_p_h + offsetHeight);
                model.lineTo(params.lean_p_d / 2 + 0.23, params.lean_p_h + offsetHeight);
                model.lineTo(params.lean_p_d / 2 + 0.23, backWallCloseSize);
                model.closePath();
            }
        } else if (params.add_left_back_lean_porch && (backWallCloseSize < sideWallCloseSize)) {
            model.moveTo(params.lean_p_d / 2 , backWallCloseSize);
            model.lineTo(params.lean_p_d / 2 , sideWallCloseSize);
            model.lineTo(params.lean_p_d / 2 + 0.23, sideWallCloseSize);
            model.lineTo(params.lean_p_d / 2 + 0.23, backWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.add_storage_check, backWallCloseSize, params.p_b_c_b_l_b, params.add_left_back_lean_porch, params.lean_p_h, params.lean_p_d, offsetHeight, params.p_b_c_b_l, sideWallCloseSize])

    // const backWallVrTrimModelTwo = useMemo(() => {
    //     const model = new THREE.Shape();

    //     if (!(params.p_b_c_b_l_b === "Open" || params.p_b_c_b_l_b === "Gable" || (params.add_left_back_lean_porch && !params.add_storage_check) || params.p_b_c_b_l === 'Close')) {
    //         model.moveTo(params.lean_p_d / 2 + 0.02, 0);
    //         model.lineTo(params.lean_p_d / 2 + 0.02, sideWallCloseSize + trimOffset - 0.1);
    //         model.lineTo(params.lean_p_d / 2 + 0.23, sideWallCloseSize + trimOffset - 0.1);
    //         model.lineTo(params.lean_p_d / 2 + 0.23, 0);
    //         model.closePath();
    //     }

    //     return model;
    // }, [params.add_storage_check, sideWallCloseSize, params.p_b_c_b_l_b, params.add_left_back_lean_porch, params.lean_p_h, params.lean_p_d, offsetHeight, params.p_b_c_b_l, trimOffset])

    const sideWallVrLeftTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l === "Open")) {
            model.moveTo(params.lean_p_d / 2 + sideWallLeftPorchSize + 0, sideWallCloseSize);
            model.lineTo(params.lean_p_d / 2 + sideWallLeftPorchSize + 0, params.lean_p_h + offsetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo(params.lean_p_d / 2 + sideWallLeftPorchSize + 0.23, params.lean_p_h + offsetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo(params.lean_p_d / 2 + sideWallLeftPorchSize + 0.23, sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.lean_p_h, params.lean_p_d, offsetHeight, sideWallCloseSize, sideWallLeftPorchSize, params.p_b_c_b_l])
    
    const sideWallVrRightTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_l === "Open")) {
            model.moveTo(-(params.lean_p_d / 2 + sideWallRightPorchSize + 0.235), sideWallCloseSize);
            model.lineTo(-(params.lean_p_d / 2 + sideWallRightPorchSize + 0.235), params.lean_p_h + offsetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo(-(params.lean_p_d / 2 + sideWallRightPorchSize + 0), params.lean_p_h + offsetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo(-(params.lean_p_d / 2 + sideWallRightPorchSize + 0), sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.lean_p_h, params.lean_p_d, offsetHeight, sideWallCloseSize, sideWallRightPorchSize, params.p_b_c_b_l])

    // const sideWallJTrimModel = useMemo(() => {
    //     if (!(params.p_b_c_b_l === "Open" || params.p_b_c_b_l === "Close")) {
    //         let model = [];

    //         if (params.add_storage_check) {
    //             const leftTrimModel = new THREE.Shape();
    //             leftTrimModel.moveTo((params.lean_p_d / 2 + sideWallLeftPorchSize + 0.23), sideWallCloseSize - 0.05);
    //             leftTrimModel.lineTo((params.lean_p_d / 2 + sideWallLeftPorchSize + 0.23), sideWallCloseSize + 0.05);
    //             leftTrimModel.lineTo((params.lean_p_d / 2 + 0.03), sideWallCloseSize + 0.05);
    //             leftTrimModel.lineTo((params.lean_p_d / 2 + 0.03), sideWallCloseSize - 0.05);
    //             leftTrimModel.closePath();                

    //             const rightTrimModel = new THREE.Shape();
    //             rightTrimModel.moveTo((params.lean_p_d / 2 - parseInt(params.add_storage)), sideWallCloseSize - 0.05);
    //             rightTrimModel.lineTo((params.lean_p_d / 2 - parseInt(params.add_storage)), sideWallCloseSize + 0.05);
    //             rightTrimModel.lineTo(-(params.lean_p_d / 2 + sideWallRightPorchSize + 0.23), sideWallCloseSize + 0.05);
    //             rightTrimModel.lineTo(-(params.lean_p_d / 2 + sideWallRightPorchSize + 0.23), sideWallCloseSize - 0.05);
    //             rightTrimModel.closePath();

    //             model.push(leftTrimModel);
    //             model.push(rightTrimModel);
    //         } else {
    //             const trimModel = new THREE.Shape();
    //             trimModel.moveTo(-(params.lean_p_d / 2 + sideWallRightPorchSize + 0.16), sideWallCloseSize - 0.05);
    //             trimModel.lineTo(-(params.lean_p_d / 2 + sideWallRightPorchSize + 0.16), sideWallCloseSize + 0.05);
    //             trimModel.lineTo((params.lean_p_d / 2 + sideWallLeftPorchSize + 0.16), sideWallCloseSize + 0.05);
    //             trimModel.lineTo((params.lean_p_d / 2 + sideWallLeftPorchSize + 0.16), sideWallCloseSize - 0.05);
    //             trimModel.closePath();

    //             model.push(trimModel);
    //         }

    //         return model;
    //     } else {
    //         const model = new THREE.Shape();
    //         return model;
    //     }


    // }, [params.add_storage_check, params.lean_p_d, sideWallCloseSize, sideWallLeftPorchSize, sideWallRightPorchSize, params.p_b_c_b_l, params.add_storage])

    const storageWallModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-params.lean_p_d / 2, 0);
        model.lineTo(-params.lean_p_d / 2 + parseInt(params.add_storage), 0);
        model.lineTo(-params.lean_p_d / 2 + parseInt(params.add_storage), params.lean_p_h);
        model.lineTo(-params.lean_p_d / 2, params.lean_p_h);
        model.closePath();

        return model;
    }, [params.lean_p_d, params.add_storage, params.lean_p_h])


    /**********************cutting hole using CSG Side************************/

    const storageVal = useMemo(() => {
        return params.add_storage_check ? Number(params.add_storage) : 0
    }, [params.add_storage_check, params.add_storage])

    const jTrimSideModelObj = useMemo(() => {
        let main;
        let wainscot;
        
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.lean_p_d + sideWallLeftPorchSize + sideWallRightPorchSize + 0.2)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanSide', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshStoragewallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageWallModel, extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
    
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set(-(params.lean_p_d / 2 + sideWallRightPorchSize + 0.15), sideWallCloseSize + 0.1, 0.0625)
        meshJTrimModel_Temp.rotation.y = Math.PI/2
        meshJTrimModel_Temp.updateMatrixWorld();

        const meshStoragewallModel_Temp = meshStoragewallModel.clone();
        meshStoragewallModel_Temp.position.set(-params.leftLeanStoragePosition, 0, 0.5);
        meshStoragewallModel_Temp.rotation.set(0, -Math.PI, 0);
        meshStoragewallModel_Temp.updateMatrixWorld();
   
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.lean_p_pos, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshStoragewallModel_CSG = CSG.fromMesh(meshStoragewallModel_Temp);
    
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        let JTrimModel_CSG;

        if(params.add_storage_check) {
            JTrimModel_CSG = JTrimModel_CSG_Temp.subtract(meshStoragewallModel_CSG)
        } else {
            JTrimModel_CSG = JTrimModel_CSG_Temp
        }
    
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG,new THREE.Matrix4())

        main =CSGJTrimModel.geometry

        let sideWainscotTrimRightPorchSize = (params.add_left_front_lean_porch && params.p_b_c_b_l == "Close") ? sideWallRightPorchSize : 0
        let sideWainscotTrimLeftPorchSize = (params.add_left_back_lean_porch && params.p_b_c_b_l == "Close") ? sideWallLeftPorchSize : 0
        let storageLength = (params.add_storage_check && params.p_b_c_b_l != "Close") ? params.lean_p_d - storageVal : 0
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_d - storageLength + sideWainscotTrimRightPorchSize + sideWainscotTrimLeftPorchSize + 0.02)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set(-(params.lean_p_d / 2 + sideWainscotTrimRightPorchSize + 0.02) + storageLength, 3 , 0.06)
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.updateMatrixWorld()

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);

        let WainscotTrimDelModel_CSG;

        if(params.add_storage_check) {
            WainscotTrimDelModel_CSG = WainscotTrimModel_CSG.subtract(meshStoragewallModel_CSG)
        } else {
            WainscotTrimDelModel_CSG = WainscotTrimModel_CSG
        }
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimDelModel_CSG,new THREE.Matrix4())

        wainscot = CSGWainscotTrimModel.geometry

        return {main, wainscot}
    }, [params.lean_p_d, sideWallLeftPorchSize, params.leftLeanStoragePosition, sideWallRightPorchSize, sideWallCloseSize, params.lean_p_pos, params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.p_b_c_b_l, params.add_storage_check, params.add_storage, params.lean_p_h, const_var.newDoorsArray])


    /**********************cutting hole using CSG for Front************************/ 

    const jTrimFrontModelObj = useMemo(() => {
        let main;
        let wainscot;

        const meshJTrimFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.lean_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanFront', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        const meshJTrimFrontModel_Temp = meshJTrimFrontModel.clone();
        meshJTrimFrontModel_Temp.position.set(-(params.lean_p_d / 2 + 0.1525), frontWallCloseSize + (params.p_r_s === 1 && params.p_b_c_b_l_f === 'Gable' ? 0.36 : 0.1), (params.lean_p_w) + 0.06)
        meshJTrimFrontModel_Temp.rotation.y = Math.PI
        meshJTrimFrontModel_Temp.updateMatrixWorld()
    
        const meshDelFrontModel_Temp = meshDelFrontModel.clone();
        meshDelFrontModel_Temp.rotateY(Math.PI / -2);
        meshDelFrontModel_Temp.position.set(-(params.lean_p_d / 2), 0, (params.lean_p_w) + params.p_w / 2 + 0.05);
        meshDelFrontModel_Temp.updateMatrixWorld()

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.lean_p_pos, 0, -0.5);
        meshSideDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimFrontModel_CSG = CSG.fromMesh(meshJTrimFrontModel_Temp);
        const meshDelFrontModel_CSG = CSG.fromMesh(meshDelFrontModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
    
        const JTrimFrontModel_CSG = meshJTrimFrontModel_CSG.subtract(meshDelFrontModel_CSG);
        const JTrimSideDelModel_CSG = JTrimFrontModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGJTrimFrontModel = CSG.toMesh(JTrimSideDelModel_CSG,new THREE.Matrix4())
        main = CSGJTrimFrontModel.geometry
        
        const meshFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_w + 0.01)))
        let meshFrontWainscotModel_Temp = meshFrontWainscotModel.clone();
        meshFrontWainscotModel_Temp.position.set(-(params.lean_p_d / 2 + 0.155), 3 , (params.lean_p_w) + 0.06)
        meshFrontWainscotModel_Temp.rotation.y = Math.PI
        meshFrontWainscotModel_Temp.updateMatrixWorld();
    
        const meshFrontWainscotModel_CSG = CSG.fromMesh(meshFrontWainscotModel_Temp);
    
        const frontWainscotModel_CSG = meshFrontWainscotModel_CSG.subtract(meshDelFrontModel_CSG);
        const SideDelModel_CSG = frontWainscotModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGFrontWainscotModel = CSG.toMesh(SideDelModel_CSG,new THREE.Matrix4())
        wainscot = CSGFrontWainscotModel.geometry

        return {main, wainscot}
    }, [params.lean_p_d, params.lean_p_w, params.p_w, frontWallCloseSize, const_var.newDoorsArray, params.lean_p_pos, params.p_r_s, params.p_b_c_b_l_f])

    /**********************cutting hole using CSG for Back************************/ 

    const jTrimBackModelObj = useMemo(() => {
        let main;
        let wainscot;

        const meshJTrimBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.lean_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanBack', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        const meshJTrimBackModel_Temp = meshJTrimBackModel.clone();
        meshJTrimBackModel_Temp.position.set((params.lean_p_d / 2 + 0.1525), backWallCloseSize + (params.p_r_s === 1 && params.p_b_c_b_l_b === 'Gable' ? 0.36 : 0.1), 0.06)
        meshJTrimBackModel_Temp.updateMatrixWorld();
    
        const meshDelBackModel_Temp = meshDelBackModel.clone();
        meshDelBackModel_Temp.rotateY(Math.PI / -2);
        meshDelBackModel_Temp.position.set((params.lean_p_d / 2) + 0.5, 0, (params.lean_p_w) + params.p_w / 2 + 0.05);
        meshDelBackModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.lean_p_pos, 0, 0);
        meshSideDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimBackModel_CSG = CSG.fromMesh(meshJTrimBackModel_Temp);
        const meshDelBackModel_CSG = CSG.fromMesh(meshDelBackModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
    
        const JTrimBackModel_CSG = meshJTrimBackModel_CSG.subtract(meshDelBackModel_CSG);
        const JTrimSideDelModel_CSG = JTrimBackModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGJTrimBackModel = CSG.toMesh(JTrimSideDelModel_CSG,new THREE.Matrix4());
        main = CSGJTrimBackModel.geometry

        const meshBackWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_w)))
        let meshBackWainscotModel_Temp = meshBackWainscotModel.clone();
        meshBackWainscotModel_Temp.position.set((params.lean_p_d / 2 + 0.155), 3 , 0.05)
        // meshBackWainscotModel_Temp.rotation.y = Math.PI
        meshBackWainscotModel_Temp.updateMatrixWorld();
    
        const meshBackWainscotModel_CSG = CSG.fromMesh(meshBackWainscotModel_Temp);
    
        const backWainscotModel_CSG = meshBackWainscotModel_CSG.subtract(meshDelBackModel_CSG);
        const SideDelModel_CSG = backWainscotModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGBackWainscotModel = CSG.toMesh(SideDelModel_CSG,new THREE.Matrix4())
        wainscot = CSGBackWainscotModel.geometry

        return {main, wainscot}
    }, [params.lean_p_d, params.lean_p_w, params.p_w, const_var.newDoorsArray, backWallCloseSize, params.lean_p_pos, params.p_r_s, params.p_b_c_b_l_b])

    /************** cutting hole in wainscot Trim using CSG for Front***************/

    // const storageFrontWall = useMemo(() => {
    //     const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_w - 0.01)))
    //     const meshFrontStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    //     const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

    //     let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
    //     meshStorageFrontWainscotModel_Temp.position.set((params.lean_p_d / 2  - parseInt(params.add_storage)), 3 , (params.lean_p_w) + 0.05)
    //     meshStorageFrontWainscotModel_Temp.rotation.y = Math.PI
    //     meshStorageFrontWainscotModel_Temp.updateMatrixWorld();
    
    //     let meshFrontStorageDelModel_Temp = meshFrontStorageDelModel.clone();
    //     meshFrontStorageDelModel_Temp.position.set((params.lean_p_d / 2  - parseInt(params.add_storage)) + 0.5, 0, ( params.p_w/2 + params.lean_p_w) + 0.05);
    //     meshFrontStorageDelModel_Temp.rotation.y = Math.PI/-2
    //     meshFrontStorageDelModel_Temp.updateMatrixWorld();

    //     let meshSideDelModel_Temp = meshSideDelModel.clone();
    //     meshSideDelModel_Temp.position.set(params.lean_p_pos, 0, -0.5 );
    //     meshSideDelModel_Temp.updateMatrixWorld();
    
    //     const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);
    //     const meshFrontStorageDelModel_CSG = CSG.fromMesh(meshFrontStorageDelModel_Temp);
    //     const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

    
    //     const storagefrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshFrontStorageDelModel_CSG);
    //     const storageSideWallDelModel_CSG = storagefrontWainscotModel_CSG.subtract(meshSideDelModel_CSG);

    //     const CSGStorageFrontWainscotModel = CSG.toMesh(storageSideWallDelModel_CSG,new THREE.Matrix4())

    //     return CSGStorageFrontWainscotModel.geometry
    // }, [params.lean_p_d, params.lean_p_w, params.add_storage, params.p_w, const_var.newDoorsArray, params.lean_p_pos])

    /****************************************************************/
    
    // --- front wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check && params.leftLeanStoragePosition === params.lean_p_d - params.add_storage) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_l_f === 'Open' || typeof(params.p_b_c_b_l_f) === 'object') {
                if (params.p_r_s === 1) {
                    tempWallCloseSize = params.lean_p_h + 0.15;
                } else {
                    tempWallCloseSize = params.lean_p_h;
                }
            } else if (params.p_b_c_b_l_f === "One_Fourth_Close") {
                tempWallCloseSize = params.lean_p_h / 4 * 3;
            } else if (params.p_b_c_b_l_f === "Gable") {
                tempWallCloseSize = params.lean_p_h - 0.2;
            } else if (params.p_b_c_b_l_f === "Half_Close") {
                tempWallCloseSize = params.lean_p_h / 2;
            } else if (params.p_b_c_b_l_f === "Three_Fourth_Close") {
                tempWallCloseSize = params.lean_p_h / 4;
            } else if (params.p_b_c_b_l_f === "Close") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_l_f === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_l_f === "Half End") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = 0;
            }
        }

        setFrontWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'LLFrontWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_l_f, params.lean_p_h, params.p_r_s, params.lean_p_d, params.leftLeanStoragePosition, params.add_storage])

    // --- back wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check && params.leftLeanStoragePosition === 0) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_l_b === 'Open' || typeof(params.p_b_c_b_l_b) === 'object') {
                if (params.p_r_s === 1) {
                    tempWallCloseSize = params.lean_p_h + 0.15;
                } else {
                    tempWallCloseSize = params.lean_p_h;
                }
            } else if (params.p_b_c_b_l_b === "One_Fourth_Close") {
                tempWallCloseSize = params.lean_p_h / 4 * 3;
            } else if (params.p_b_c_b_l_b === "Gable") {
                tempWallCloseSize = params.lean_p_h - 0.2;
            } else if (params.p_b_c_b_l_b === "Half_Close") {
                tempWallCloseSize = params.lean_p_h / 2;
            } else if (params.p_b_c_b_l_b === "Three_Fourth_Close") {
                tempWallCloseSize = params.lean_p_h / 4;
            } else if (params.p_b_c_b_l_b === "Half End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_l_b === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_l_b === "Close") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = 0;
            }
        }

        setBackWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'LLBackWallCloseState': tempWallCloseSize}))
    }, [params.add_storage_check, params.p_b_c_b_l_b, params.lean_p_h, params.p_r_s, params.leftLeanStoragePosition])

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_l === 'Open' || typeof(params.p_b_c_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.lean_p_h + 0.15;
            } else {
                tempWallCloseSize = params.lean_p_h;
            }
        } else if (params.p_b_c_b_l === "One_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4 * 3;
        } else if (params.p_b_c_b_l === "Half_Close") {
            tempWallCloseSize = params.lean_p_h / 2;
        } else if (params.p_b_c_b_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4;
        } else if (params.p_b_c_b_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.lean_p_h - 3 * params.p_b_c_b_l;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_l, params.lean_p_h, params.p_r_s])
    
    // --- porch state
    useMemo(() => {
        if (params.add_left_back_lean_porch) {
            setSideWallLeftPorchSize(params.lean_p_w);
        } else {
            setSideWallLeftPorchSize(0);
        }
    }, [params.add_left_back_lean_porch, params.lean_p_w, params.p_r_s])

    useMemo(() => {
        if (params.add_left_front_lean_porch) {
            setSideWallRightPorchSize(params.lean_p_w);
        } else {
            setSideWallRightPorchSize(0);
        }
    }, [params.add_left_front_lean_porch, params.lean_p_w, params.p_r_s])

    return (
        <>
            <group  position={[-(params.p_w / 2 + params.lean_p_w + 0.05 + wallThickness), 0, 0]} rotation={[0, Math.PI / 2, 0]}>
                <mesh name="front-wall-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[frontWallVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"leftLean"} />
                </mesh>
                <mesh name="back-wall-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[backWallVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"leftLean"} />
                </mesh>
                <mesh name="side-wall-left-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[sideWallVrLeftTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"leftLean"} />
                </mesh>
                <mesh name="side-wall-right-trim"position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[sideWallVrRightTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"leftLean"} />
                </mesh>

                <mesh name="left-lean-front-trim" position={[(params.p_d - params.lean_p_d) / 2 + 0.03, 0, (params.lean_p_w)]}>
                    <extrudeGeometry args={[leftLeanFrontTrimModel, extrudeSettings(0.23)]} />
                    <MaterialTrim visibleSection={"leftLean"} />
                </mesh>
                
                <mesh name="left-lean-back-trim" position={[-(params.p_d - params.lean_p_d) / 2 - 0.03, 0, (params.lean_p_w)]}>
                    <extrudeGeometry args={[leftLeanBackTrimModel, extrudeSettings(0.225)]} />
                    <MaterialTrim visibleSection={"leftLean"} />
                </mesh>

                {sideJTrimState &&
                    // <mesh name="side-wall-J-trim">
                    //     <extrudeGeometry args={[sideWallJTrimModel, extrudeSettings(0.16)]} />
                    //     <MaterialTrim visibleSection={"leftLean"} /> 
                    // </mesh>
                    <mesh name="side-wall-J-trim" geometry={jTrimSideModelObj.main}>
                        <MaterialTrim visibleSection={"leftLean"} />
                    </mesh>
                }
                {frontJTrimState &&
                    <mesh name="side-wall-J-trim" geometry={jTrimFrontModelObj.main}>
                        <MaterialTrim visibleSection={"leftLean"} />
                    </mesh>
                }
                {backtJTrimState &&
                    <mesh name="side-wall-J-trim" geometry={jTrimBackModelObj.main}>
                        <MaterialTrim visibleSection={"leftLean"} />
                    </mesh>
                }
                {/* {params.add_storage_check &&
                    <mesh name="storage-wall-trim" position={[-parseInt(params.add_storage) - 0.1 - offset, 0, -0.02]}>
                        <extrudeGeometry args={[backWallVrTrimModelTwo, extrudeSettings(0.22)]} />
                        <MaterialTrim visibleSection={"leftLean"} />
                    </mesh>
                } */}

                {params.p_w_c_n == true && (params.p_b_c_b_l == "Close") &&
                    <mesh name="wainscotTrim" geometry={jTrimSideModelObj.wainscot} >
                        <MaterialWainScotTrimNew   visibleSection={"leftlean"}/>
                    </mesh>
                }
                {params.p_w_c_n == true && params.p_b_c_b_l_f == "Close" &&
                    <mesh name="L_L_F_W_wainscotTrim" geometry={jTrimFrontModelObj.wainscot} >
                        <MaterialWainScotTrimNew   visibleSection={"leftlean"}/>
                    </mesh>
                }
                {params.p_w_c_n == true && params.p_b_c_b_l_b == "Close" &&
                    <mesh name="L_L_B_W_wainscotTrim" geometry={jTrimBackModelObj.wainscot} >
                        <MaterialWainScotTrimNew   visibleSection={"leftlean"}/>
                    </mesh>
                }
                
                {/* {params.p_w_c_n == true && params.add_storage_check &&
                    <mesh name="wainscotTrim" geometry={storageFrontWall} position={[-offset, 0, 0]} >
                        <MaterialWainScotTrimNew visibleSection={"leftLean"} />
                    </mesh>
                } */}
            </group>
            <mesh position={[ -(params.lean_p_w / 2 + params.p_w / 2), 0, params.lean_p_d / 2 + 0.1]} >
                <extrudeGeometry args={[dutchDelModelFront, extrudeSettings(0.15)]}/>
                <MaterialTrim visibleSection={"leftLean"} />
            </mesh>
            <mesh position={[ -(params.lean_p_w / 2 + params.p_w / 2), 0, - (params.lean_p_d / 2 + 0.25)]} >
                <extrudeGeometry args={[dutchDelModelBack, extrudeSettings(0.15)]}/>
                <MaterialTrim visibleSection={"leftLean"} />
            </mesh>
        </>
    )
}

export default TrimModel